<template>
  <md-card>
    <md-card-header
      v-if="!this.loaded"
      class="md-card-header-icon md-card-header-green"
    >
      <div class="card-icon">
        <md-icon class="load-rotate">hourglass_empty</md-icon>
      </div>
      <h4 class="title">Laden</h4>
    </md-card-header>
    <md-card-header
      v-if="this.loaded"
      class="md-card-header-icon md-card-header-green"
    >
      <div class="card-icon">
        <md-icon>today</md-icon>
      </div>
      <h4 class="title">{{ periodType["label"] }}</h4>
    </md-card-header>
    <md-card-content>
      <md-checkbox v-model="includeArchived"
        >Toon perioden in het verleden</md-checkbox
      >
      <md-table
        v-if="this.loaded"
        :value="queriedData"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
        :md-sort-fn="sortAll"
        class="paginated-table table-striped table-hover"
      >
        <md-table-toolbar>
          <md-field>
            <label for="pages">Perioden per pagina</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>

          <md-field>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Zoek periode(n)"
              v-model="searchQuery"
            >
            </md-input>
          </md-field>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell
            class="cursor-pointer"
            @click.native="handleEdit(item)"
            md-label="Label"
            md-sort-by="label"
          >
            {{ item.label }}
          </md-table-cell>
          <md-table-cell
            class="cursor-pointer"
            @click.native="handleEdit(item)"
            md-label="Start datum"
            md-sort-by="startDate"
          >
            {{ formatDate(item.startDate) }}
          </md-table-cell>
          <md-table-cell
            class="cursor-pointer"
            @click.native="handleEdit(item)"
            md-label="Stop datum"
            md-sort-by="stopDate"
          >
            {{ formatDate(item.stopDate) }}
          </md-table-cell>
          <md-table-cell
            class="cursor-pointer"
            @click.native="handleEdit(item)"
            md-label="Herhalend"
            md-sort-by="recurringYearly"
          >
            <div class="card-icon" v-if="item.recurringYearly === 0">
              <md-icon class="text-danger">close</md-icon>
              Nee
            </div>
            <div class="card-icon" v-if="item.recurringYearly === 1">
              <md-icon class="text-success">check</md-icon>
              Ja
            </div>
          </md-table-cell>
          <md-table-cell md-label="Verwijderen">
            <div class="md-group">
              <md-button
                class="md-just-icon md-danger md-simple"
                @click.native="handleDelete(item)"
              >
                <md-icon>delete</md-icon>
              </md-button>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <md-card-actions v-if="this.loaded" md-alignment="space-between">
      <div class="">
        <p class="card-category">
          Weergave van {{ from + 1 }} t/m {{ to }} van {{ total }} perioden
        </p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
    </md-card-actions>
    <md-card-actions v-if="this.loaded">
      <md-button
        native-type="button"
        @click.native.prevent="handleAdd"
        class="md-success"
        >{{ periodType["label"] }} toevoegen</md-button
      >
    </md-card-actions>
  </md-card>
</template>

<script>
import { Option, Select, Table, TableColumn } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  props: ["periods", "periodType", "loaded"],
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    tableDataFiltered: function() {
      var data = [];
      for (var i in this.tableData) {
        if (
          this.includeArchived === false &&
          this.getTimestampForDate(this.tableData[i].stopDate) <
            this.timestampNow &&
          this.tableData[i].recurringYearly === 0
        ) {
          continue;
        }

        data.push(this.tableData[i]);
      }

      return data;
    },
    queriedData() {
      let result = this.tableDataFiltered;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDataFiltered.length;
    }
  },
  data() {
    return {
      currentSort: "startDate",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      footerTable: ["Label", "Start datum", "Stop datum"],
      searchQuery: "",
      propsToSearch: ["label", "startDate", "stopDate"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      includeArchived: false,
      timestampNow: Math.floor(Date.now() / 1000)
    };
  },
  methods: {
    handleAdd() {
      this.$router.push(
        "/drivers/edit/" + this.$route.params.id + "/unavailablePeriod/add"
      );
    },
    handleEdit(item) {
      this.$router.push(
        "/drivers/edit/" +
          this.$route.params.id +
          "/unavailablePeriod/edit/" +
          item.id
      );
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Periode "${item.name}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http
            .delete(this.$apiBaseUrl + "drivers/unavailableperiods/" + item.id)
            .then(
              response => {
                this.deleteRow(item);

                this.notifyVue(
                  "Periode succesvol verwijderd",
                  "check",
                  "success",
                  5000
                );

                // Fuse search initialization.
                this.fuseSearch = new Fuse(this.tableDataFiltered, {
                  keys: ["label", "startDate", "stopDate"],
                  threshold: 0.3
                });
              },
              response => {
                if (response.status === 403) {
                  this.notifyVue(
                    "U heeft geen rechten voor het beheren van Chauffeur perioden",
                    "add_alert",
                    "danger",
                    0
                  );
                }
              }
            );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    getTimestampForDate(date) {
      return Math.floor(new Date(date + "T23:59:59.999+0200").getTime() / 1000);
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    }
  },
  mounted() {
    this.tableData = this.periods;

    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableDataFiltered, {
      keys: ["label", "startDate", "stopDate"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableDataFiltered;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
</style>
